import * as buffer from 'buffer';
global.Buffer = buffer.Buffer;
